<template>
  <el-dialog v-model="visible" title="审核" width="30%">
    <el-dialog title="请输入不通过的原因" v-model="approvalVisible" width="30%">
      <el-input
        type="textarea"
        v-model="reason"
        :rows="3"
        :maxlength="200"
        show-word-limit
      />
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="(approvalVisible = false), (reason = '')"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click="handleApproval(4)"
            :disabled="buttonLoading"
          >
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>
    <span>请选择是否通过审核</span>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          type="danger"
          @click="(approvalVisible = true), (reason = '')"
          >不通过</el-button
        >
        <el-button
          type="primary"
          @click="handleApproval(3)"
          :disabled="buttonLoading"
        >
          通过
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref } from "vue";
import { submitApproval } from "@/api/approval";
import { ElMessage } from "element-plus";

const emits = defineEmits(["afterApproval"]);

const visible = ref(false);

const approvalVisible = ref(false);

const reason = ref("");

const dialogConfig = ref({});

// 按钮loading
const buttonLoading = ref(false);

// 弹窗打开
const handleDialogOpen = (row) => {
  dialogConfig.value = { ...row };
  visible.value = true;
};

// 审核
const handleApproval = (type) => {
  if (type == 4 && !reason.value) return ElMessage.error("请输入驳回原因");
  buttonLoading.value = true;
  submitApproval({
    id: dialogConfig.value.id,
    operateType: type, // 1-发起审核、2-同意、3-驳回
    submitType: "2", //  1-发起审核、2-领导审核
    serialNumber: dialogConfig.value.serialNumber,
    reason: reason.value,
  }).then((res) => {
    if (res.code == "2000") {
      ElMessage.success("操作成功");
      emits("afterApproval");
      visible.value = false;
    }
  });
  setTimeout(() => {
    buttonLoading.value = false;
  }, 300);
};

defineExpose({
  handleDialogOpen,
});
</script>

<style lang="scss" scoped></style>
